import { Country } from 'react-phone-number-input';

import { useTranslations } from '~src/commons/utils/translations/translate';
import { FullscreenComponent } from '~src/fullscreen-internals/fullscreen-mode';
import { useGlobalState } from '~src/global-state';
import { LocationModalLayout } from '~src/location/location-modal-layout';
import { Button } from '~src/ui/button';
import { Dialog } from '~src/ui/dialog';

import { useListState } from '../ui/list-state';
import { CountrySelectList } from './country-select-list';

interface CountrySelectModalProps {
  countryNames: Record<string, string>;
  onClose: () => void;
  onSubmit: (newCountry: string) => void;
}

export const CountrySelectModal: FullscreenComponent<CountrySelectModalProps> = ({
  countryNames,
  onClose,
  onSubmit,
}) => {
  const globalState = useGlobalState();
  const { tICU } = useTranslations();

  const countries = globalState
    .available_purchase_countries!.included_codes!.map(country => [
      country,
      countryNames[`country.${country}`],
    ])
    .filter(country => country[1] !== undefined)
    .sort((countryA, countryB) => countryA[1].localeCompare(countryB[1]));

  const listState = useListState({
    items: countries as [Country, string][],
    getKey: (country: [Country, string]) => country[0],
    defaultSelectedKey: globalState.purchase_country,
  });

  const callSubmit = () => {
    if (listState.selectedKey !== globalState.purchase_country) {
      onSubmit(listState.selectedKey);
    } else {
      onClose();
    }
  };

  return (
    <Dialog height={600} width={520} onClose={onClose}>
      <LocationModalLayout
        title={tICU('widget.country_select.HEADER')}
        listElement={<CountrySelectList listState={listState} />}
        buttonElement={
          <Button type="submit" onClick={callSubmit}>
            {tICU('widget.delivery_address.SAVE_CHOICE_BTN')}
          </Button>
        }
        onClose={onClose}
      />
    </Dialog>
  );
};
CountrySelectModal.fullscreenName = 'CountrySelectModal';
